import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_12W_66_65_12W_66_65',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_v2_12w_66_65_12w_66_65_usd',
			ARS: 'simple_premium_12w_89190_12w_89190_ars',
			COP: 'simple_premium_12w_269990_12w_269990_cop',
			CLP: 'simple_premium_12w_64990_12w_64990_clp',
		},
		primer: 'prd_wlUgE7otqhKd',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 84,
		priceMap: {
			USD: 66.65,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
			ARS: 89190,
			COP: 269990,
			CLP: 64990,
		},
		originalPriceMap: {
			USD: 66.65,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
			ARS: 89190,
			COP: 269990,
			CLP: 64990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 66.65,
			AUD: 99.99,
			BRL: 379,
			CAD: 89.99,
			DKK: 439,
			EUR: 66.65,
			GBP: 66.65,
			MXN: 1279,
			NOK: 669,
			PLN: 249,
			SEK: 639,
			TRY: 2900,
			ARS: 89190,
			COP: 269990,
			CLP: 64990,
		},
	},
}
